import React from "react";
import { connect } from "react-redux";
// import Menu from "./Menu";
import ActionButton from "../ActionButton";
import Header from "../Header";
import ProductHeader from "./NavHeader";
// import GridView from "./GridView";
import { setProduct } from "../../store/actions";
import instance from "../../store/actions/instance";
import List from "./Menu/List";
import WhenDoYouWantIt from "./WhenDoYouWantIt";
import PhoneNumber from "./PhoneNumber";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import DistributorInfo from "./DistributorInfo";
import PaymentMethod from "./PaymentMethod";
import TotalCharge from "./TotalCharge";
import ProfileDrawer from "./ProfileDrawer";
import AppliedCoupons from "./AppliedCoupons";
import B2BCart from "./Cart";
import Menu from "./Menu";
import {
  cartToQuantity,
  setUsedComponents,
  setB2BNoticeBannerVisibility,
  fetchCategories,
  checkMOV,
  checkWalletBalance,
  setPhoneNumber,
  setVerifiedPhone,
  setMethod,
  setDistributor,
  setBranchDetails,
} from "../../store/actions/b2b";
import SpecialRemarks from "../CheckoutProcess/Confirmation/SpecialRemarks";
import Search from "./Search";
import { ReactComponent as PoweredByOrdable } from "../assets/poweredByOrdable.svg";
import NoticeBannerB2B from "../Banner/Notice/NoticeBannerB2B";
import PopupBanner from "../Banner/Popup";
import DownloadQuotation from "./PaymentMethod/DownloadQuotation";
import PasswordPage from "./PasswordPage";
import PreviousOrderAgain from "./PreviousOrderAgain";

class index extends React.Component {
  storeInfoB2B = React.createRef();

  state = {
    loading: false,
    products: null,
    categories: null,
    phoneNumber: "",
    distributor: null,
    cart: {},
    phoneNumberError: false,
    accountName: this.props.branch?.account_name || "",
    accountEmail: this.props.branch?.email || "",
    accountAddress: this.props.branch?.address || "",
    accountPhone: this.props.branch?.phone || "",
    checkbox: false,
    didMeetMOV: false,
    date: "",
    buttonLoading: false,
    method: "none",
    paymentError: false,
    deliveryPrice: this.props.branch?.deliveryPrice || 0,
    subTotal: 0,
    hasEnoughBalance: false,
    promotion: null,
    cartDrawerOpen: false,
    search: "",
    specialRemarks: "",
    success: false,
    categories: null,
  };
  handlePhoneNumberChange = (e) => {
    this.setState({ phoneNumber: e.target.value });
    this.props.setPhoneNumber(e.target.value);
    if (e.target.value.length >= 7) {
      this.getBranchInfo(e.target.value);
    }
    if (e.target.value.length < 7) {
      this.setState({ accountName: "", checkbox: false });
    }
  };

  async getBranchInfo(number) {
    const res = await instance.post(`/get_branch_info/`, {
      phone: number,
      slug: this.props.match.params.slug,
    });
    this.setState({
      accountName: res.data.account_name,
      deliveryPrice: res.data.deliveryPrice || 0,
      accountEmail: res.data.email,
      accountAddress: res.data.address,
      accountPhone: res.data.phone,
    });
    this.props.setBranchDetails(res.data);
  }

  validationSuccess = (success) => {
    this.setState({ success: success });
  };

  async checkMOV(cart) {
    const res = await instance.post(`/check_mov/`, {
      cart: cart,
      slug: this.props.match.params.slug,
    });
    this.setState({ didMeetMOV: res.data == 1 ? true : false });
  }

  handleDateChange = (e) => {
    this.setState({ date: e.target.value });
  };
  handleCheckbox = (e) => {
    this.setState({ checkbox: e.target.checked });
    this.props.setVerifiedPhone(e.target.checked);
    if (e.target.checked)
      this.props.checkWalletBalance(
        this.props.match.params.slug,
        this.props.phoneNumber,
        this.props.cart
      );
  };
  componentDidMount = () => {
    this.fetchDistributorInfo();
    this.props.setB2BNoticeBannerVisibility(true);
  };
  handlePlaceOrder = () => {
    if (!this.props.phoneNumber) {
      this.setState({ phoneNumberError: true });
      window.scrollTo(0, document.body.scrollHeight);
      return;
    }
    if (
      this.props.method === "none" &&
      (this.state.distributor.enable_online_payments ||
        this.state.distributor.enable_cash_payments)
    ) {
      window.scrollTo(0, document.body.scrollHeight);
      return;
    }

    if (!this.props.hasEnoughBalance && this.props.method === "on-credit") {
      this.props.setB2BProfileOpen(true);
      return;
    }
    if (
      this.props.settings.enable_b2b_cart &&
      this.state.cartDrawerOpen === false
    ) {
      this.setState({ cartDrawerOpen: true });
      return;
    }
    this.placeOrder();
  };

  async fetchDistributorInfo() {
    const res = await instance.post(`/get_distributor_info/`, {
      slug: this.props.match.params.slug,
    });
    if (res.data == -1) return this.props.history.replace("/");
    let leadTime = res.data.lead_time;
    let todayName = moment().format("dddd").toLowerCase();

    if (res.data[`deliver_on_${todayName}`]) {
      if (moment().format("HH:mm") > res.data[`${todayName}_cutoff`]) {
        leadTime += 1;
      }
    } else {
      leadTime += 1;
    }
    let initialDate = moment().locale("en").add(leadTime, "days");
    while (true) {
      if (
        (initialDate.isoWeekday() == 7 && !res.data.deliver_on_sunday) ||
        (initialDate.isoWeekday() == 1 && !res.data.deliver_on_monday) ||
        (initialDate.isoWeekday() == 2 && !res.data.deliver_on_tuesday) ||
        (initialDate.isoWeekday() == 3 && !res.data.deliver_on_wednesday) ||
        (initialDate.isoWeekday() == 4 && !res.data.deliver_on_thursday) ||
        (initialDate.isoWeekday() == 5 && !res.data.deliver_on_friday) ||
        (initialDate.isoWeekday() == 6 && !res.data.deliver_on_saturday)
      ) {
        initialDate = initialDate.add(1, "days");
      } else break;
    }
    if (!res.data.enable_on_credit_payments) this.props.hideB2BUserButton();

    let categories = {};
    res.data.products.forEach((product) => {
      const categoryId = product.product.category;
      if (!categories[categoryId]) {
        categories[categoryId] = {
          category_name: product.product.category_name,
          category_ar_name: product.product.category_ar_name,
          slug: product.product.category_slug,
          id: categoryId,
          products: [],
        };
      }
      categories[categoryId].products.push(product);
    });
    this.setState({
      distributor: res.data,
      products: res.data.products,
      categories: Object.values(categories),
      date: initialDate.format("YYYY-MM-DD"),
    });
    this.props.setDistributor(res.data);
    this.props.fetchCategories(Object.values(categories));
    this.props.setDistributorNoticeBannerOverride(res.data.override_banner);
    this.props.setDistributorNoticeBanner(res.data.enable_banner);
  }

  async placeOrder() {
    this.setState({ buttonLoading: true });
    let cart = this.props.cart;
    for (const cartKey in cart) {
      if (cart[cartKey] <= 0) {
        delete cart[cartKey];
      }
    }
    const res = await instance.post(`/place_distributor_order/`, {
      slug: this.props.match.params.slug,
      cart: cart,
      date: this.state.date,
      phone: this.props.phoneNumber,
      method: this.props.method,
      promotion: this.state.promotion,
      special_remarks: this.state.specialRemarks,
      delivery_charges: false,
      delivery_charge_only: false,
    });
    if (res.data.success) {
      if (res.data.url) {
        window.location.href = res.data.url;
      } else {
        this.props.history.push("/distributor/success/", {
          tracking_id: res.data.tracking_id,
        });
        this.setState({ buttonLoading: false });
        this.setState({ cartDrawerOpen: false });
        this.props.emptyCart();
      }
    } else {
      this.props.history.push("/distributor/fail/", {
        message: res.data.message,
      });
      this.setState({ buttonLoading: false });
      this.setState({ cartDrawerOpen: false });
      this.props.emptyCart();
    }
  }

  addItemToCart = (id, quantity) => {
    let cart = this.props.cart;
    if (quantity == 0 && cart[id] != null) {
      delete cart[id];
    } else cart[id] = quantity;

    this.props.checkMOV(cart, this.props.match.params.slug);
    this.props.checkWalletBalance(
      this.props.match.params.slug,
      this.props.phoneNumber,
      cart
    );

    this.setState({ cart: cart });
  };

  handleChange = (value) => {
    this.setState({ method: value, paymentError: false });
    this.props.setMethod(value);
    if (value === "on-credit")
      this.props.checkWalletBalance(
        this.props.match.params.slug,
        this.props.phoneNumber,
        this.props.cart,
        value
      );
  };

  didChoosePaymentMethod = () => {
    const { distributor } = this.state;
    if (
      distributor.enable_cash_payments ||
      distributor.enable_online_payments ||
      distributor.enable_on_credit_payments
    ) {
      if (this.props.method !== "none") return true;
      else return false;
    }
    return true;
  };
  get_distributor_info;

  getDiscountTotal = () => {
    let price = this.getSubTotal();
    let discount_amount = 0;
    const { promotion } = this.state;
    if (this.state.distributor.distributor_discounts.length) {
      let discounts = this.state.distributor.distributor_discounts.filter(
        (d) => d.is_active
      );
      discounts.forEach((discount) => {
        if (discount.type == "delivery") {
          discount_amount += this.state.deliveryPrice;
        }
        if (discount.type == "fixed") {
          discount_amount += discount.amount;
        }
        if (discount.type == "percent") {
          discount_amount += (price * discount.amount) / 100;
        }
      });
    }
    if (promotion) {
      if (promotion?.discount_type === "delivery") {
        discount_amount += this.state.deliveryPrice;
      }
      if (promotion?.discount_type === "fixed") {
        discount_amount += promotion?.discount_amount;
      }
      if (promotion?.discount_type === "percent") {
        discount_amount += (price * promotion?.discount_amount) / 100;
      }
    }
    return discount_amount;
  };
  getSubTotal = () => {
    const ids = Object.keys(this.props.cart);
    if (!ids?.length) return 0;

    let subtotal = 0;
    ids.forEach((id) => {
      const price =
        this.state.distributor.products.find(
          (p) => p.product.id === parseInt(id)
        )?.product?.price || 0;
      subtotal += price * this.props.cart[id];
    });
    return subtotal;
  };

  handlePromotion = (data) => {
    this.setState({ promotion: data });
  };
  toggleDrawer = (value) => {
    this.setState({ cartDrawerOpen: value });
  };
  handleRemoveItemFromCart = (product) => {
    let cart = this.props.cart;
    this.props.setUsedComponents({
      product: product,
      quantityDelta: cart[product.id],
    });
    delete cart[product.id];
    this.props.cartToQuantity(product.id, 0, true);
    this.props.checkMOV(product.id, this.props.match.params.slug);
    this.props.checkWalletBalance(
      this.props.match.params.slug,
      this.props.phoneNumber,
      this.props.cart
    );
    this.setState({ cart: cart });
    if (Object.keys(cart).length === 0) {
      this.setState({ cartDrawerOpen: false });
    }
  };
  handleEmptyCart = () => {
    this.setState({ cart: {} });
    this.setState({ cartDrawerOpen: false });
    this.props.emptyCart();
    this.props.checkMOV({}, this.props.match.params.slug);
    this.props.checkWalletBalance(
      this.props.match.params.slug,
      this.props.phoneNumber,
      this.props.cart
    );
  };

  render() {
    const language = this.props.language;
    let customTexts = this.props.settings.custom_texts;

    if (this.state.loading || !this.state.products) return <></>;
    if (!this.props.isB2B) this.props.setB2B();
    const actionButtonText = () => {
      if (language == "english") {
        if (!this.props.didMeetMOV && !Object.keys(this.props.cart).length)
          return "Add items to cart";
        else if (!this.props.didMeetMOV && Object.keys(this.props.cart).length)
          return "Add more to cart";
        else if (
          this.props.didMeetMOV &&
          !this.props.checkbox &&
          this.state.accountName
        )
          return "Verify your account";
        else if (
          this.props.didMeetMOV &&
          this.props.checkbox &&
          this.state.accountName &&
          this.didChoosePaymentMethod() &&
          (this.props.hasEnoughBalance ||
            this.props.method !== "on-credit" ||
            this.props.balanceCheckLoading)
        ) {
          if (this.props.settings.enable_b2b_cart) {
            return customTexts.review_order;
          } else {
            return customTexts.place_order;
          }
        } else if (this.props.didMeetMOV && !this.state.accountName)
          return "Enter your phone number";
        else if (this.props.method === "none") return "Choose a payment method";
        else if (
          this.props.method === "on-credit" &&
          !this.props.hasEnoughBalance &&
          !this.props.balanceCheckLoading
        )
          return "Insufficient credit. Click to top-up";
      } else {
        if (!this.props.didMeetMOV && !Object.keys(this.props.cart).length)
          return "ابدأ بإضافة المنتجات";
        else if (!this.props.didMeetMOV && Object.keys(this.props.cart).length)
          return `اضف المزيد من المنتجات`;
        else if (
          this.props.didMeetMOV &&
          !this.props.checkbox &&
          this.state.accountName
        )
          return "تأكد من معلومات حسابك";
        else if (
          this.props.didMeetMOV &&
          this.props.checkbox &&
          this.state.accountName &&
          this.didChoosePaymentMethod() &&
          (this.props.hasEnoughBalance ||
            this.props.method !== "on-credit" ||
            this.props.balanceCheckLoading)
        ) {
          if (this.props.settings.enable_b2b_cart) {
            return customTexts.review_order_ar;
          } else {
            return customTexts.place_order_ar;
          }
        } else if (this.props.didMeetMOV && !this.state.accountName)
          return "ادخل رقم الهاتف";
        else if (this.props.method === "none") return "اختر طريقة دفع";
        else if (
          this.props.method === "on-credit" &&
          !this.props.hasEnoughBalance &&
          !this.props.balanceCheckLoading
        )
          return "رصيدك غير كافي. اضغط للتعبة";
      }
    };

    if (this.state.distributor.has_password && !this.state.success) {
      return (
        <PasswordPage
          distributor={this.state.distributor}
          onValidation={(success) => this.validationSuccess(success)}
        />
      );
    }
    return (
      <>
        {this.props.settings.enable_popup_banner && this.props.isB2B && (
          <PopupBanner isB2B />
        )}
        <NoticeBannerB2B
          isB2B={this.props.isB2BNoticeBannerVisible}
          distributor={this.state.distributor}
        />

        <div className="d-lg-none d-xl-none d-md-none">
          <ProductHeader
            homePage={true}
            storeInfoRef={this.storeInfoB2B}
            appRef={this.props.appRef}
            enableSearch={true}
            logo={this.state.distributor.logo}
            distributorBannerOverride={this.state.distributor.override_banner}
            distributorEnableBanner={this.state.distributor.enable_banner}
          />
        </div>
        {this.state.cartDrawerOpen && (
          <B2BCart
            cart={this.props.cart}
            handleEmptyCart={this.handleEmptyCart}
            handleRemoveItemFromCart={this.handleRemoveItemFromCart}
            placeOrder={this.placeOrder}
            getSubTotal={this.getSubTotal}
            getDiscountTotal={this.getDiscountTotal}
            distributor={this.state.distributor}
            deliveryPrice={this.state.deliveryPrice}
            didMeetMOV={this.props.didMeetMOV}
            balanceCheckLoading={this.props.balanceCheckLoading}
            didChoosePaymentMethod={this.didChoosePaymentMethod}
            checkbox={this.props.checkbox}
            handlePlaceOrder={this.handlePlaceOrder}
            actionButtonText={actionButtonText()}
            buttonLoading={this.state.buttonLoading}
            products={this.state.products}
            cartDrawerOpen={this.state.cartDrawerOpen}
            toggleDrawer={this.toggleDrawer}
            customTexts={customTexts}
          />
        )}
        <ProfileDrawer slug={this.props.match.params.slug} />
        <div
          className="col-12 d-lg-none d-xl-none d-md-none p-0 m-0"
          style={{ height: 300, width: "100%" }}
        >
          <Header imageSize={300} />
        </div>
        {/* <StoreInfo /> */}
        <span ref={this.storeInfoB2B}></span>
        <DistributorInfo
          logo={this.state.distributor.logo}
          name={this.state.distributor.name}
        />

        {/* {this.props.promos && <Promo />} */}
        <Search
          handleSearch={(e) => this.setState({ search: e.target.value })}
        />
        {/* <PreviousOrderAgain
          distributor={this.state.distributor}
          categories={this.state.categories}
          products={this.state.products}
          addItemToCart={(id, quantity) => this.addItemToCart(id, quantity)}
          handleChange={this.handleChange}
        /> */}
        {this.state.categories.length ? (
          <Menu
            filter
            filter_value={this.state.search}
            products={this.state.products}
            categories={this.state.categories}
            addItemToCart={(id, quantity) => this.addItemToCart(id, quantity)}
            showPrices={this.state.distributor.show_prices}
          />
        ) : null}
        <WhenDoYouWantIt
          distributor={this.state.distributor}
          handleDateChange={this.handleDateChange}
          date={this.state.date}
        />
        {this.props.settings.enable_b2b_special_remarks && (
          <SpecialRemarks
            setSpecialRemarks={(e) =>
              this.setState({ specialRemarks: e.target.value })
            }
            specialRemarks={this.state.specialRemarks}
            isB2B
          />
        )}
        <PhoneNumber
          handlePhoneNumberChange={this.handlePhoneNumberChange}
          phoneNumber={this.props.phoneNumber}
          phoneNumberError={this.state.phoneNumberError}
          accountName={this.state.accountName}
          handleCheckbox={this.handleCheckbox}
          checkboxValue={this.props.checkbox}
        />
        {this.props.settings.enable_b2b_coupons && (
          <AppliedCoupons
            promotion={this.state.promotion}
            handlePromotion={this.handlePromotion}
          />
        )}
        {(this.state.distributor.enable_cash_payments ||
          this.state.distributor.enable_online_payments ||
          this.state.distributor.enable_on_credit_payments) && (
          <PaymentMethod
            setPaymentMethod={this.props.setPaymentMethod}
            distributor={this.state.distributor}
            handleChange={this.handleChange}
            value={this.props.method}
            paymentError={this.state.paymentError}
          />
        )}

        {this.state.distributor.can_download_quotation && (
          <DownloadQuotation
            cart={this.props.cart}
            businessName={this.state.distributor.name}
            products={this.state.distributor.products}
            disableButton={
              this.props.checkbox &&
              this.didChoosePaymentMethod() &&
              this.props.didMeetMOV &&
              this.state.accountName
            }
            accountName={this.state.accountName}
            date={this.state.date}
            showPrice={this.state.distributor.show_prices}
            total={this.getSubTotal() + this.state.deliveryPrice}
            subtotal={this.getSubTotal()}
            discountTotal={this.getDiscountTotal()}
            deliveryPrice={this.state.deliveryPrice}
            vat={this.state.distributor.vat_rate}
            paymentDays={this.state.distributor.payment_days}
            paymentMethod={this.props.method}
            phoneNumber={this.props.phoneNumber}
            accountEmail={this.state.accountEmail}
            accountAddress={this.state.accountAddress}
            accountPhone={this.state.accountPhone}
          />
        )}

        {this.state.distributor?.show_prices && (
          <TotalCharge
            total={this.getSubTotal() + this.state.deliveryPrice}
            subtotal={this.getSubTotal()}
            discountTotal={this.getDiscountTotal()}
            deliveryPrice={this.state.deliveryPrice}
            distributor={this.state.distributor}
          />
        )}
        <ActionButton
          action={
            !this.state.buttonLoading ? (
              actionButtonText()
            ) : (
              <span>
                <CircularProgress
                  style={{ width: 30, height: 30, color: "white" }}
                />
              </span>
            )
          }
          b2b
          onClick={!this.state.buttonLoading ? this.handlePlaceOrder : () => {}}
          placeOrderButtonDisabled={
            !this.props.checkbox ||
            !this.props.didMeetMOV ||
            !this.didChoosePaymentMethod() ||
            this.props.balanceCheckLoading
          }
        />
        {!this.props.store.settings.is_whitelabel ? (
          <>
            <p
              className="text-center w-100 mb-4"
              style={{
                fontWeight: "normal",

                position: "relative",
                top: "-5px",
              }}
            >
              <a
                href={`https://www.itsordable.com/?utm_source=${window.location.hostname}&utm_medium=store&utm_campaign=powered_by&utm_content=${language}`}
                target="_blank"
                style={{
                  color: "#666",
                  fontSize: "12px",
                }}
              >
                {language === "english"
                  ? "powered by ordable/"
                  : "/بدعم من اوردبل"}
              </a>
            </p>
          </>
        ) : (
          <></>
        )}
        {!this.state.distributor?.show_prices ? (
          <div className="free-space-110"></div>
        ) : (
          <div className="free-space-165"></div>
        )}
      </>
    );
    // }
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    promos: state.store.store.promos,
    settings: state.store.store.settings,
    branch: state.branch,
    isB2B: state.store.isB2B,
    isNotificationDismissedB2B: state.b2b.isNotificationDismissedB2B,
    isB2BNoticeBannerVisible: state.b2b.isB2BNoticeBannerVisible,
    cart: state.b2b.cartToQuantity,
    didMeetMOV: state.b2b.didMeetMOV,
    balanceCheckLoading: state.b2b.balanceCheckLoading,
    hasEnoughBalance: state.b2b.hasEnoughBalance,
    method: state.b2b.method,
    phoneNumber: state.b2b.phoneNumber,
    checkbox: state.b2b.checkbox,
    branch: state.b2b.branch,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setDistributor: (dist) => dispatch(setDistributor(dist)),
    setBranchDetails: (branch) => dispatch(setBranchDetails(branch)),
    setProduct: (prd) => dispatch(setProduct(prd)),
    setUsedComponents: (payload) => dispatch(setUsedComponents(payload)),
    setB2B: () => dispatch({ type: "SET_B2B" }),
    hideB2BUserButton: () => dispatch({ type: "HIDE_B2B_USER_BUTTON" }),
    setB2BProfileOpen: (val) =>
      dispatch({ type: "SET_B2B_PROFILE_OPEN", payload: val }),
    cartToQuantity: (id, value) => dispatch(cartToQuantity(id, value)),
    checkMOV: (cart, slug) => dispatch(checkMOV(cart, slug)),
    setMethod: (value) => dispatch(setMethod(value)),
    fetchCategories: (value) => dispatch(fetchCategories(value)),
    checkWalletBalance: (slug, phone, cart, method = null) =>
      dispatch(checkWalletBalance(slug, phone, cart, method)),
    setPhoneNumber: (value) => dispatch(setPhoneNumber(value)),
    setVerifiedPhone: (value) => dispatch(setVerifiedPhone(value)),
    emptyCart: () => dispatch({ type: "EMPTY_CART" }),
    setB2BNoticeBannerVisibility: (value) =>
      dispatch(setB2BNoticeBannerVisibility(value)),
    setDistributorNoticeBanner: (value) =>
      dispatch({
        type: "SET_DISTRIBUTOR_NOTICE_BANNER",
        payload: value,
      }),
    setDistributorNoticeBannerOverride: (value) =>
      dispatch({
        type: "SET_DISTRIBUTOR_NOTICE_BANNER_OVERRIDE",
        payload: value,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
